import { t } from 'i18next';

import { MAX_INGREDIENTS, MIN_INGREDIENTS } from '~constants/customPizza';
import { COUNTRIES } from '~constants/environment';
import { pizzaCrusts, pizzaSizes } from '~constants/products';

export const getIngredientsQuantity = ingredients =>
  ingredients?.reduce((acc, ingredient) => acc + ingredient?.quantity, 0);

export const ingredientsValidations = ingredients =>
  [
    getIngredientsQuantity(ingredients) < MIN_INGREDIENTS && t('OptionsProduct:minIngredientsError'),
    getIngredientsQuantity(ingredients) > MAX_INGREDIENTS &&
      t('OptionsProduct:maxIngredientsError', { max: MAX_INGREDIENTS })
  ].find(Boolean);

export const getHalfMenuableId = (item, side) => item?.halves?.[side]?.menuableId;

export const DEFAULT_PIZZA_SIZE = {
  [COUNTRIES.cl]: pizzaSizes.FAMILY,
  [COUNTRIES.pa]: pizzaSizes.MEDIUM,
  [COUNTRIES.es]: pizzaSizes.MEDIUM,
  [COUNTRIES.pt]: pizzaSizes.MEDIUM,
  [COUNTRIES.gt]: pizzaSizes.MEDIUM,
  [COUNTRIES.cr]: pizzaSizes.MEDIUM
};

export const DEFAULT_PIZZA_CRUST = {
  [COUNTRIES.es]: pizzaCrusts.TRADITIONAL,
  [COUNTRIES.cl]: pizzaCrusts.TRADITIONAL,
  [COUNTRIES.pt]: pizzaCrusts.TRADITIONAL,
  [COUNTRIES.gt]: pizzaCrusts.ORIGINAL,
  [COUNTRIES.cr]: pizzaCrusts.ORIGINAL,
  [COUNTRIES.pa]: pizzaCrusts.ORIGINAL
};
